import { useSearchParams } from 'hooks/useSearchParams';

export const useDraftEmployeeId = () => {
  const { urlParams, addSearchParams } = useSearchParams();
  const draftId = urlParams.get('draftId');

  const setDraftId = (draftId: string) => {
    addSearchParams([{ key: 'draftId', value: draftId }]);
  };

  return {
    draftEmployeeId: Number(draftId),
    setDraftId,
  };
};
